export const CREATE_NOTE = gql`
    mutation CreateNote($input: NoteInput!) {
        createNote(input: $input) {
            id
            createdAt
            body
            createdById
            createdBy {
                id
                firstName
                lastName
            }
        }
    }
`;
export const DELETE_NOTE = gql`
    mutation DeleteNote($id: Int!) {
        deleteNote(id: $id) {
            id
        }
    }
`;
